import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { themeType } from 'types';
import { Icon } from 'components/atoms';

const LogoUA = ({
  version, size, theme, modifiers, color,
}) => {
  const height = useMemo(() => {
    let heightRem = theme.sizes.xl3;
    switch (size) {
    case 'small':
      heightRem = theme.sizes.xl3;
      break;
    case 'medium':
      heightRem = theme.sizes.xl5;
      break;
    case 'large':
      heightRem = theme.sizes.xl6;
      break;
    default:
      heightRem = theme.sizes.xl3;
    }
    const pixelBase = 16;
    const heightInt = Number(heightRem.split('rem')[0]) * pixelBase;
    return heightInt;
  }, [size, theme.sizes.xl3, theme.sizes.xl5, theme.sizes.xl6]);

  if (version === 'desktop') {
    return (
      <Icon
        icon="logo-ua"
        height={height}
        modifiers={modifiers}
        color={color}
      />
    );
  }
  if (version === 'mobile') {
    return (
      <Icon
        icon="logo-ua-mobile"
        height={height}
        modifiers={modifiers}
        color={color}
      />
    );
  }
  if (version === 'desktop-centered') {
    return (
      <Icon
        icon="logo-ua-centered"
        height={height}
        modifiers={modifiers}
        color={color}
      />
    );
  }
  return <Icon icon="ua" height={height} modifiers={modifiers} color={color} />;
};

LogoUA.propTypes = {
  version: PropTypes.oneOf(['desktop', 'desktop-centered', 'mobile', 'icon']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  theme: themeType.isRequired,
  modifiers: PropTypes.oneOfType([
    PropTypes.oneOf(['inverse']),
    PropTypes.arrayOf(PropTypes.string),
  ]),
  color: PropTypes.string,
};

LogoUA.defaultProps = {
  version: 'desktop',
  size: 'large',
  modifiers: ['dafuq'],
  color: null,
};

export default withTheme(LogoUA);
